// Local fallback content — shown until the matching content exists in WordPress
// (cms.loansalaah.com / cms.loansalaah.in) or if WP is briefly unreachable.
// Once the owner publishes hero slides / partners / posts in WP, those replace
// this file's content live.
import { ALL_PARTNERS } from "@/lib/partners";
import { PERSONAL_LOAN_BLOGS } from "@/lib/blogs/personal";
import { HOME_LOAN_BLOGS } from "@/lib/blogs/home";
import { BUSINESS_LOAN_BLOGS } from "@/lib/blogs/business";
import { LAP_BLOGS } from "@/lib/blogs/lap";
import { CREDIT_CARD_BLOGS } from "@/lib/blogs/creditCards";
import { BALANCE_TRANSFER_BLOGS } from "@/lib/blogs/balanceTransfer";

export const FALLBACK_IDENTITY = {
  name: "Loan Salaah",
  tagline: "Salaah you can bank on.",
  icon: "",
  url: "",
};

export const FALLBACK_SLIDES = [
  {
    id: "fallback-1",
    eyebrow: "DSA · Loan Marketplace",
    title: "The loan that fits your life.",
    subtitle:
      "Loan Salaah compares offers from our partner banks and structures your application — so you borrow with clarity, not guesswork.",
    image_url:
      "https://images.unsplash.com/photo-1730130596425-197566414dc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBtb2Rlcm4lMjBob21lJTIwZmFtaWx5JTIwZmluYW5jaWFsJTIwYXNwaXJhdGlvbmFsfGVufDB8fHx8MTc5MjAxMDE3NHww&ixlib=rb-4.1.0&q=85",
    cta_label: "Calculate your EMI",
    cta_href: "/emi-calculator",
  },
  {
    id: "fallback-2",
    eyebrow: "Home · Business · Personal · Cards",
    title: "One salaah for every borrowing decision.",
    subtitle:
      "From your first home to the right credit card — indicative loan rates from 7.40% p.a. and cards matched to your spending, under one roof.",
    image_url:
      "https://images.unsplash.com/photo-1745301558339-44eb3217d5da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBJbmRpYW4lMjBhcmNoaXRlY3R1cmUlMjBob3VzZSUyMGludGVyaW9yJTIwZ29sZCUyMGludmVzdG1lbnQlMjBmaW5hbmNlfGVufDB8fHx8MTc5MjAxMDE4MHww&ixlib=rb-4.1.0&q=85",
    cta_label: "Explore products",
    cta_href: "/#products",
  },
];

export const FALLBACK_PARTNERS = ALL_PARTNERS.map((p, i) => ({ id: `fp-${i}`, ...p }));

export const HOME_FAQ = [
  {
    q: "Is Loan Salaah a bank or an NBFC?",
    a: "No. Loan Salaah is a Direct Selling Agent (DSA) and facilitator. We compare loan and credit card offers from our partner banks and NBFCs and help you structure a strong application. Every lending or card-issuance decision is made solely by the bank or NBFC.",
  },
  {
    q: "Are the interest rates shown on this website final?",
    a: "No — all rates on this site are indicative starting rates. Your final rate depends on your credit profile, income, the product and the lender's assessment at the time you apply.",
  },
  {
    q: "Do you check or calculate my CIBIL score?",
    a: "Never. We are not a credit bureau — we do not pull, calculate or estimate credit scores. Our calculators run entirely on your device and an enquiry is not an application. Only when you formally apply does the bank or card issuer check your credit report as part of their own process.",
  },
  {
    q: "What happens after I submit an enquiry?",
    a: "A Loan Salaah advisor calls you to understand your requirement, shortlists suitable banks or card issuers from our partner network, and helps you prepare documents and the application. You always see the offer before you accept it.",
  },
];

export const DSA_DISCLAIMER =
  "Loan Salaah is a Direct Selling Agent (DSA) and facilitator — not a bank or NBFC. We compare loan and credit card offers from our partner banks and assist with your application. All lending and card-issuance decisions, rates, limits and disbursals rest solely with the respective banks and NBFCs. We do not calculate or provide credit scores. Interest rates shown are indicative and subject to the lender's assessment.";

// 60 original Loan Salaah articles — 10 per product category.
export const FALLBACK_BLOGS = [
  ...PERSONAL_LOAN_BLOGS,
  ...HOME_LOAN_BLOGS,
  ...BUSINESS_LOAN_BLOGS,
  ...LAP_BLOGS,
  ...CREDIT_CARD_BLOGS,
  ...BALANCE_TRANSFER_BLOGS,
].sort((a, b) => new Date(b.date) - new Date(a.date));
